const styles = theme => ({
    appbar: {
        backgroundColor: theme.palette.green.dark,
        zIndex: theme.zIndex.drawer + 1
    },
    toolbar: {
        padding: 0
    },
    menuButton: {
        marginLeft: '16px',
        marginRight: theme.spacing(4.5),
    },
    typography: {
        color: theme.palette.green.contrastText,
        flex: 1
    },
    office: {
        color: theme.palette.green.light,
    },
    typographySubtitle: {
        color: theme.palette.green.contrastText,
        flex: 1,
        marginLeft: theme.spacing(6.5),
        marginTop: theme.spacing(-0.875),
    },
    flag: {
        marginRight: theme.spacing(1),
    },
    hide: {
        display: 'none',
    },
    envLabel: {
        fontSize: '40px',
        color: theme.palette.red.light,
        fontWeight: '700',
        marginRight: '5%'
    },
    appBarShift: {
        marginLeft: '200px',
        width: 'calc(100% - 200px)',
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    '@media (max-width: 600px)': {
        hideMobile: {
            display: 'none',
        },
    }
});

export default styles;
